<template>
    <div class="role_warp">
      <!-- 头部工具栏 -->
      <div class="role_heard_tool">
        <el-button
          type="success"
          size="mini"
          
          @click="getList"
          >刷新</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px"
          @click="select()"
          >筛选</el-button
        >
          <!-- <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-left: 10px;background:#06CC00;border:1px solid #06CC00;margin-bottom: 5px;"
        @click="checkSuccessList(2)"
        >批量通过</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-left: 10px;background:#FF0000;border:1px solid #FF0000;margin-bottom: 5px;"
        @click="checkRejectList(2)"
        >批量拒绝</el-button
      > -->
      </div>
      <div class="head_search">
        <div class="item_warp">
          <label style="margin: 0 10px;">卖家</label>
          <el-input
            v-model="memberUid"
            placeholder="请输入卖家"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
        <div class="item_warp">
          <label style="margin: 0 10px;">商品出售码</label>
          <el-input
            v-model="sn"
            placeholder="请输入商品出售码"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
        <div class="item_warp">
        <label style="margin: 0 10px">操作状态</label>
        <el-select v-model="status" style="width: 120px" placeholder="请选择" clearable>
          <el-option label="不限" value=""></el-option>
          <el-option label="正在审核" value="0"></el-option>
          <el-option label="出售中" value="1"></el-option>
          <el-option label="待买家付款" value="2"></el-option>
          <el-option label="待确定收款" value="3"></el-option>
          <el-option label="交易成功" value="4"></el-option>
          <el-option label="已下架" value="5"></el-option>
          <el-option label="审核失败" value="6"></el-option>
        </el-select>
      </div>
      </div>
      <!-- 表单 -->
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        height="calc(100vh - 240px )"
        style="width: 1601px"
        size="mini"
        @selection-change="handleSelectionChange"
      >
       <!-- <el-table-column type="selection" width="50" /> -->
       <el-table-column prop="address" label="操作" width="130">
          <template slot-scope="scoped">
            <div style="display: flex;align-items: center;justify-content: center;" v-if="scoped.row.status == 0">
                <el-popconfirm title="确定通过？" style="margin-right: 6px;" @confirm="checkSuccessList(1,scoped.row)">
                  <el-button slot="reference" type="primary" class="edit-button">通过</el-button >
                </el-popconfirm>
                <el-popconfirm title="确定拒绝？" @confirm="checkRejectList(1,scoped.row)">
                  <el-button slot="reference" type="primary" class="edit-button">拒绝</el-button >
                </el-popconfirm>
            </div>
            <div style="display: flex;align-items: center;justify-content: center;" v-if="scoped.row.status == 1 || scoped.row.status == 6">
                <el-popconfirm title="确定下架？" @confirm="ccSaleDelist(scoped.row)">
                  <el-button slot="reference" type="primary" class="edit-button">下架</el-button >
                </el-popconfirm>
            </div>
            <div style="display: flex;align-items: center;justify-content: center;" v-if="scoped.row.status == 3">
                <el-popconfirm title="确定修改？" style="margin-right: 6px;" @click="confirmReceipt(scoped.row)">
                  <el-button slot="reference" type="primary" class="edit-button">已收款</el-button >
                </el-popconfirm>
                <el-popconfirm title="确定修改？" @confirm="noReceipt(scoped.row)">
                  <el-button slot="reference" type="primary" class="edit-button">未收款</el-button >
                </el-popconfirm>
            </div>
            <div style="display: flex;align-items: center;justify-content: center;color:#999" v-if="scoped.row.status == 0">
                正在审核
            </div> 
            <div style="display: flex;align-items: center;justify-content: center;color: #999" v-if="scoped.row.status == 1">
                出售中
            </div>
            <div style="display: flex;align-items: center;justify-content: center;color: red;" v-if="scoped.row.status == 2">
                待买家付款
            </div>
            <div style="display: flex;align-items: center;justify-content: center;color: red;" v-if="scoped.row.status == 3">
                待确定收款
            </div>
            <div style="display: flex;align-items: center;justify-content: center;color: #06CC00;" v-if="scoped.row.status == 4">
                交易成功
            </div>
            <div style="display: flex;align-items: center;justify-content: center;color: #999;" v-if="scoped.row.status == 5">
                已下架
            </div>
            <div style="display: flex;align-items: center;justify-content: center;color: red;" v-if="scoped.row.status == 6">
              审核不通过
            </div>
          </template>
        </el-table-column> 
        <el-table-column prop="memberUid" label="卖家" width="100" />
        <el-table-column prop="sn" label="商品出售码" width="100" />
        <el-table-column prop="name" label="空投包" width="100" />
        <el-table-column prop="saleCount" label="出售数量" width="100" />
        <el-table-column prop="memberUid" label="出售单价" width="100">
          <template slot-scope="scope">
            <div>{{ scope.row.price }} {{ scope.row.currency }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="memberUid" label="USDT总价" width="100">
          <template slot-scope="scope">
            <div>${{ scope.row.usdtPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="withdrawSum" label="附件配图" width="240">
          <template slot-scope="scoped">
            <div style="display: flex;flex-wrap: wrap;">
                <el-image style="height: 60px;margin-left: 10px;max-width: 50px;" v-for="(item,index) in scoped.row.images" :key="index" :src="item+'?x-oss-process=image/resize,w_50'" fit="fill" :preview-src-list="previewImg(scoped.row.images)" @click.stop="handleClickItem"/>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="paymentMethods" label="收款方式" width="300" />
        <el-table-column prop="paymentInstructions" label="收款说明" width="300" />
        <el-table-column prop="contact" label="联系方式" width="200" />
        <el-table-column prop="memberUid" label="Whatsapp" width="150">
          <template slot-scope="scope">
            <div>+{{ scope.row.whatsAreaCode }} {{ scope.row.whatsPhone }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="telegram" label="Telegram" width="100" />
        <el-table-column prop="safeCode" label="面对面安全码" width="110" />
        <el-table-column prop="ccBuyerUid" label="最新买家UID" width="110" />
        <el-table-column prop="myReceiveDate" label="付款截至时间" width="170">
          <template slot-scope="scope">
            <div v-if="scope.row.buyerPayDate">{{ happenTimeFun(scope.row.buyerPayDate) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="myReceiveDate" label="实际付款时间" width="170">
          <template slot-scope="scope">
            <div v-if="scope.row.transferDate">{{ happenTimeFun(scope.row.transferDate) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="myReceiveDate" label="交易成功时间" width="170">
          <template slot-scope="scope">
            <div v-if="scope.row.successDate">{{ happenTimeFun(scope.row.successDate) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="170" />
      </el-table>
      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pageNum"
        :limit.sync="pageSize"
        @pagination="getList"
      />
      <el-dialog
      :visible.sync="edit_dialogVisible"
      width="500px"
      title="上传历史"
      :center="true"
      :close-on-click-modal="false"
      @close="closeIsEnabled()"
    >
      <!-- 编辑用户表格 -->
      <div>
        <div v-for='(item,index) in historyList' :key='index'>
          <div style="display: flex;align-items: center;">{{item.createDate }} <span v-if='item.status == 2' style="color: red;margin-left: 5px;">已拒绝</span> </div>
          <div style="display: flex;flex-wrap: wrap;margin: 10px 0;">
                <el-image style="height: 60px;margin-left: 10px;max-width: 50px;" v-for="(itm,ind) in item.images" :key="ind" :src="itm" fit="fill" :preview-src-list="item.images" @click.stop="handleClickItem"/>
            </div>
        </div>
      </div>
    </el-dialog>
    </div>
  </template>
  
  <script>
  import Pagination from "@/components/Pagination"; // 引入分页器
  import UploadImage from "@/components/Upload/UploadPic"; // 引入分页器
  import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
  
  import validEmail from "@/utils/validate"; // 引入邮箱验证方法
  import md5 from "js-md5"; // 引入Md5加密
  
  export default {
    name: "Management",
    components: { Pagination,VueUeditorWrap,UploadImage },
    data() {
      return {
        option: "", // 初始选项
        options: [], // 选择角色
        name: "", // 搜索的管理员名称
        tableData: [], // 展示的表单信息
        // 添加表单
        active: {},
        // 修改表单
        editForm: { },
        total: 0, // 总数
        pageNum: 1, // 页码值
        pageSize: 20, // 页大小
        historyList: [], // 选中项s
        yiFangDetailList: [], // 
        dialogVisible: false, // 添加弹窗
        dialog: false, // 添加弹窗
        edit_dialogVisible: false, // 编辑弹窗
        Isedit: false, // 是否是编辑弹窗
        loading: false, // 表格加
        buttongLoding: false, // 按钮加载
        sn:'',
        lang:'en',
        isEnabled:false,
        isChat:false,
        isTelegram:false,
        isWhatsApp:false,
        isMessenger:false,
        isLinkUrl:false,
        isTelegramGroup:false,
        dialogVisibleUpdate:false,
        dataTime:['',''],
        yifangId:'',
        status:'',
        ipCount:'',
        sn:'',
        memberUid:''
        
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
    getChildrenSum(row) {
      this.historyList = row;
      this.edit_dialogVisible = true
    },
      handleClickItem() {
        this.$nextTick(() => {
          // 获取遮罩层dom
          const domImageMask = document.querySelector('.el-image-viewer__mask')
          if (!domImageMask) {
            return
          }
          domImageMask.addEventListener('click', () => {
            // 点击遮罩层时调用关闭按钮的 click 事件
            document.querySelector('.el-image-viewer__close').click()
          })
        })
      },
      // 筛选
      select() {
        this.pageNum = 1;
        this.getList();
      },
      previewImg(list){
    let list1 = []
    list.forEach(item => {
      list1.push(item+'?x-oss-process=image/resize,w_450')
    })
    return list1
  },
      // 批量审核通过
    checkSuccessList(type,row){
        if(type == 1){
      this.$api.c2c
        .approve({
            id:row.id
        })
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
  
        }
        if(type == 2){
            if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否批量审核通过?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.c2c
        .approveList(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
          
      })
  
        }
    },
    ccSaleDelist(row){
      this.$api.c2c
        .ccSaleDelist({
            id:row.id
        })
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
    },
    confirmReceipt(row){
      this.$api.c2c
        .confirmReceipt({
            id:row.id
        })
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
    },
    noReceipt(row){
      this.$api.c2c
        .noReceipt({
            id:row.id
        })
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
    },
    checkRejectList(type,row){
      console.log(123)
        if(type == 1){
      this.$api.c2c
        .reject({
            id:row.id
        })
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
  
        }
      if(type == 2){
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否批量审核拒绝?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.c2c
        .rejectList(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
          
      }).catch(() => {
        
        });
      }
    },
    selectOrder(name, type) {
      this.myAmount = "";
      this.c1 = "";
      this.inviteCount = "";
      if (name == "IP数量") {
        this.ipCount = type;
      }
      if (name == "下级数量") {
        this.c1 = type;
      }
  
      this.pageNum = 1;
      this.getList();
    },
      // 获取表单信息
      getList() {
        var params = {
          pageNumber: this.pageNum,
          pageSize: this.pageSize,
          memberUid:this.memberUid,
          status:this.status,
          sn:this.sn
        };
        this.loading = true;
        this.$refs.gridTable.bodyWrapper.scrollTop = 0;
          this.$api.c2c
          .ccSaleList(params)
          .then((res) => {
            this.tableData = res.records;
            this.total = res.total;
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
      // 选择或者取消行，支持全选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 关闭添加弹窗
      handleClose() {
        this.$refs.active.resetFields();
      },
      // 关闭修改弹窗
      editClose(done) {
        this.editInfo = {};
        done();
      },
      // 删除选中项
      handleDel() {
        var ids = [];
        this.multipleSelection.forEach((item) => {
          ids.push(item.id);
        });
        var params = {
          ids: ids.toString(),
        };
        this.$api.c2c
          .bannerDelete(params)
          .then((res) => {
            this.$message.success(res);
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.getList();
          });
      },
      happenTimeFun(num){
      let date = new Date(num);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d; //天补0
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s; //秒补0
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
  },
      // 添加用户
      bannerSave() {
            this.$api.c2c
              .bannerSave(this.active)
              .then((res) => {
                this.$message.success(res);
                this.dialogVisible = false;
                this.getList();
              })
              .catch((err) => {
                this.$message.error(err || "服务器错误，请稍后重试");
              })
              .finally(() => {
                this.buttongLoding = false;
              });
      },
      // 打开删除弹窗
      openDelete() {
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
          return this.$message.info("你并没有选中任何选项");
        }
        this.$confirm("是否删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.handleDel();
          })
          .catch(() => {
            
          });
      },
     
    },
  };
  </script>
  <style lang="scss" scoped>
  .role_warp {
    font-size: 14px;
    padding: 10px;
    box-sizing: border-box;
    .role_heard_tool {
      margin-bottom: 10px;
    }
    .edit_titile {
      .dialog_input {
        // width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 70%;
        span {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          margin-right: 20px;
        }
        .el-input {
          flex: 3;
        }
      }
    }
    .tree {
      margin-top: 25px;
      display: flex;
      justify-content: space-around;
    }
    .authority_info {
      margin-top: 25px;
    }
  }
  .el-input {
    width: 70%;
  }
  ::v-deep .el-pagination{
  white-space: wrap !important;
  }
  </style>
  